import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import { FaTrailer, FaShippingFast, FaDigitalTachograph } from "react-icons/fa";
import { BsPersonVcard } from "react-icons/bs";
import { MdShareLocation } from "react-icons/md";

import ProfileModal from "./Components/ProfileModal/CarrierProfileModal";
import AuthComponent from "../../Pages/Authentication/Components/AuthComponent/AuthComponent";
import Navbar from "./Navbar";

const CarrierNavbar = () => {
  const user = useSelector((state) => state.user);
  const [carrierPermissions, setCarrierPermissions] = useState([]);

  useEffect(() => {
    setCarrierPermissions([
      {
        label: "Zones",
        i18nKey: "nav:zones",
        url: "/create-zone",
        name: "",
        unReadData: null,
        icon: MdShareLocation,
      },
      {
        label: "Shipments",
        i18nKey: "nav:shipments",
        url: "/dispatcher",
        name: "",
        unReadData: null,
        icon: FaTrailer,
      },
      {
        label: "Finances",
        i18nKey: "nav:finances",
        url: "/carrier-payments",
        name: "",
        unReadData: null,
        icon: FaDigitalTachograph,
      },
      {
        label: "Drivers",
        i18nKey: "nav:drivers",
        url: "/drivers",
        name: "",
        unReadData: null,
        icon: BsPersonVcard,
      },
      {
        label: "Vehicles",
        i18nKey: "nav:vehicles",
        url: "/vehicles",
        name: "",
        unReadData: null,
        icon: FaShippingFast,
      },
    ]);
  }, [user]);

  const profileModal = ({ onClose }) => (
    <ProfileModal onClose={onClose} style={{ top: "50px", right: "0" }} />
  );

  return (
    <>
      <AuthComponent />
      <Navbar
        navItems={carrierPermissions}
        profileImage={user?.profile_image}
        profileModal={profileModal}
      />
    </>
  );
};

export default CarrierNavbar;
